import { render, staticRenderFns } from "./StockInformation.vue?vue&type=template&id=24af3820&scoped=true&"
import script from "./StockInformation.vue?vue&type=script&lang=js&"
export * from "./StockInformation.vue?vue&type=script&lang=js&"
import style0 from "./StockInformation.vue?vue&type=style&index=0&id=24af3820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af3820",
  null
  
)

export default component.exports